import React, { useMemo } from "react";
import Home1 from "./Home1";
import Home2 from "./Home2";
import Home3 from "./Home3";

const Home = () => {
  const userRole = useMemo(() => {
    try {
      const user = JSON.parse(
        localStorage.getItem("userDetails")
      );

      return String(user?.data?.user?.role || "")
        .trim()
        .toLowerCase();
    } catch {
      return "";
    }
  }, []);

  if (["cashmaker", "cashchecker"].includes(userRole)) {
    return <Home3 />;
  }

  const allowedRoles = [
    "storekeeper",
    "admin",
    "superadmin",
    "director",
    "pomaker",
    "pochecker",
    "accounts",
    "billing"
  ];

  return allowedRoles.includes(userRole)
    ? <Home2 />
    : <Home1 />;
};

export default Home;